/** @type {import('../lib/dataTable').DataTableColumn[]} */
export const SALES_LINK_REGISTER_COLUMNS = [
  {
    id: "linked_at",
    label: "Linked",
    accessor: (row) => row.sales_linked_at || row.created_at,
    filterType: "date",
    sortable: true,
  },
  { id: "vehicle_number", label: "Vehicle", accessorKey: "vehicle_number", filterType: "text" },
  { id: "gate_pass_code", label: "Gate pass", accessorKey: "gate_pass_code", filterType: "text" },
  { id: "party_name", label: "Party", accessorKey: "party_name", filterType: "text" },
  { id: "sales_contract_number", label: "Contract", accessorKey: "sales_contract_number", filterType: "text" },
  { id: "variety", label: "Variety", accessorKey: "variety", filterType: "text" },
  { id: "state", label: "Status", accessorKey: "state", filterType: "text" },
  { id: "sales_linked_by", label: "Linked by", accessorKey: "sales_linked_by", filterType: "text" },
];

/** @type {import('../lib/dataTable').DataTableColumn[]} */
function joinLoadLines(row, pick, fallback) {
  const lines = Array.isArray(row?.load_lines) && row.load_lines.length ? row.load_lines : null;
  if (!lines) return fallback(row);
  return lines.map((line) => pick(line)).filter((v) => v != null && v !== "").join(" · ");
}

export const LOADING_REGISTER_COLUMNS = [
  { id: "loaded_at", label: "Date", accessorKey: "loaded_at", filterType: "date", sortable: true },
  { id: "vehicle_number", label: "Vehicle", accessorKey: "vehicle_number", filterType: "text" },
  { id: "gate_pass_code", label: "GP", accessorKey: "gate_pass_code", filterType: "text" },
  { id: "party_name", label: "Party", accessorKey: "party_name", filterType: "text" },
  {
    id: "production_batch_code",
    label: "Batch",
    accessor: (row) => joinLoadLines(row, (l) => l.production_batch_code, (r) => r.production_batch_code),
    filterType: "text",
  },
  {
    id: "crop_name",
    label: "Crop",
    accessor: (row) => joinLoadLines(row, (l) => l.crop_name, (r) => r.crop_name),
    filterType: "text",
  },
  {
    id: "item_name",
    label: "Item",
    accessor: (row) => joinLoadLines(row, (l) => l.item_name, (r) => r.item_name),
    filterType: "text",
  },
  {
    id: "bags_loaded",
    label: "Bags",
    accessor: (row) => joinLoadLines(row, (l) => l.bags_loaded, (r) => r.bags_loaded),
    filterType: "text",
  },
  {
    id: "packing_label",
    label: "Packing",
    accessor: (row) =>
      joinLoadLines(
        row,
        (l) => (l.weight_per_bag ? `${l.weight_per_bag} kg` : ""),
        (r) => r.packing_label,
      ),
    filterType: "text",
  },
  {
    id: "net_weight_qtl",
    label: "Net weight",
    accessor: (row) => joinLoadLines(row, (l) => l.weight_loaded_qtl, (r) => r.net_weight_qtl),
    filterType: "text",
  },
  { id: "loaded_by", label: "Loaded by", accessorKey: "loaded_by", filterType: "text" },
];

/** @type {import('../lib/dataTable').DataTableColumn[]} */
export const SALES_VOUCHER_REGISTER_COLUMNS = [
  {
    id: "voucher_at",
    label: "Issued",
    accessor: (row) => row.sales_voucher_at || row.gross_weighed_at || row.created_at,
    filterType: "date",
    sortable: true,
  },
  { id: "sales_voucher_code", label: "Voucher", accessorKey: "sales_voucher_code", filterType: "text" },
  { id: "vehicle_number", label: "Vehicle", accessorKey: "vehicle_number", filterType: "text" },
  { id: "gate_pass_code", label: "Gate pass", accessorKey: "gate_pass_code", filterType: "text" },
  { id: "party_name", label: "Party", accessorKey: "party_name", filterType: "text" },
  { id: "sales_contract_number", label: "Contract", accessorKey: "sales_contract_number", filterType: "text" },
  { id: "net_weight_qtl", label: "Net", accessorKey: "net_weight_qtl", filterType: "text" },
  { id: "sales_voucher_by", label: "Issued by", accessorKey: "sales_voucher_by", filterType: "text" },
];

/** @type {import('../lib/dataTable').DataTableColumn[]} */
export const OUTWARD_WEIGHMENT_REGISTER_COLUMNS = [
  {
    id: "weigh_date",
    label: "Date",
    accessor: (row) => row.gross_weighed_at || row.tare_weighed_at || row.created_at,
    filterType: "date",
    sortable: true,
  },
  { id: "vehicle_number", label: "Vehicle", accessorKey: "vehicle_number", filterType: "text" },
  { id: "gate_pass_code", label: "Gate pass", accessorKey: "gate_pass_code", filterType: "text" },
  { id: "party_name", label: "Party", accessorKey: "party_name", filterType: "text" },
  { id: "tare_weight_qtl", label: "Tare", accessorKey: "tare_weight_qtl", filterType: "text" },
  { id: "gross_weight_qtl", label: "Gross", accessorKey: "gross_weight_qtl", filterType: "text" },
  { id: "net_weight_qtl", label: "Net", accessorKey: "net_weight_qtl", filterType: "text" },
  { id: "sales_voucher_code", label: "Sales voucher", accessorKey: "sales_voucher_code", filterType: "text" },
];
